const translations = {
  "en": {
    "What you get:": "What you get:"
  },
  "zh-tw": {
    "What you get:": "你將獲得："
  }
};

export default translations;
